import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "distance-range" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "distance-range__divider" }, "-", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NSelect = _resolveComponent("NSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NSelect, {
      modelValue: _ctx.modelValueGte,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValueGte) = $event)),
      items: _ctx.minItems,
      selectonly: "",
      placeholder: "0",
      "clear-icon": ""
    }, null, 8, ["modelValue", "items"]),
    _hoisted_2,
    _createVNode(_component_NSelect, {
      modelValue: _ctx.modelValueLte,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelValueLte) = $event)),
      items: _ctx.maxItems,
      selectonly: "",
      placeholder: "1000",
      "clear-icon": ""
    }, null, 8, ["modelValue", "items"])
  ]))
}